// color constants
export const wegDe = '#FF9700';
export const wegDePrimary50 = '#fff5e6';
export const checkboxHoverColor = 'rgb(245, 248, 250)';
export const darkLava = '#1E0023';
export const outlineFocusColor = '#1868DB';
export const trustYouOther = '#D9D4CA';
export const trustYouPoor = '#D9D4CA';
export const trustYouFair = '#F8CE72';
export const trustYouGood = '#BFCC4E';
export const trustYouVeryGood = '#A0CA3F';
export const trustYouExcellent = '#7CB342';
export const pinkPeople = '#f2007d';
export const pinkPeople50 = '#fee6f2';
